import {ClsAccessToken} from './cls-access-token';
import {ClsErrores} from './cls-errores';

export class ClsEncabezadoReporte {
  Empresa: string;
  Cliente: string;
  Obra: string;
  Lugar: string;
  Ciudad: string;
  Estado: string;
  FechaInicioLic: Date;
  FechaFinalLic: Date;
  Logo: string;
  Responsable: string;
  CargoResponsable: string;
  Iva: number;
  TotalPresupuesto: number;
  NumeroConcurso: string;
  DuracionConcurso: string;
  ImprimirIVA?: boolean;
}

export class ClsReporte {
  AccessToken: ClsAccessToken;
  Nombre: string;
  NuevoNombre: string;
  Contenido: any; // cambiar al tipo de dato correspondiente
  ObjReportes?: ClsReporte[];
  Errores?: ClsErrores;
}

export class ClsRutaReportes {
  Nombre: string;
  Nivel: string;
  Padre: string;
  Ruta: string;
  Reportes: ClsRutaReportes[];
}

export class ClsReportes {
  AccessToken: ClsAccessToken;
  Reportes: ClsReporte[];
}

export class ClsOpcionesReportes {
  Clasificacion: string;
  Orden: string;
  Base64String: string;
  Formato: string;
  TiposInsumos: number[];
  RangoInicial: string;
  RangoFinal: string;
  OpcionEquipos: number;
  ConDescripcionLarga: boolean;
  Logo: any;
  TipoMoneda: number;
  ImprimirMarcadas: any;
  /** Índices detalle prog. suministro: 1=montos, 2=porcentajes, 3=cantidades. */
  DetalleOpcionesProgSum?: number[];
  /** Encabezado columnas periodo: porPeriodo | porFecha. */
  EncabezadoPeriodosProgSum?: string;
}

/** Fila base reporte programa de suministros (columnas P{n}_* dinámicas). */
export interface IReporteProgSumBase {
  Codigo: string;
  Descripcion: string;
  DescripcionLarga?: string;
  Unidad: string;
  CantidadCapturado: number;
  MontoCapturado: number;
  PorcentajeCapturado: number;
  [key: string]: unknown;
}

export interface IReporteProgSumMateriales extends IReporteProgSumBase {
  Costo: number;
}

export interface IReporteProgSumManoObra extends IReporteProgSumBase {
  AreaTrabajo: string;
  SalarioReal: number;
}

export interface IReporteProgSumEquipo extends IReporteProgSumBase {
  CostoPorHora: number;
  Capacidad: string;
  Potencia: number;
  DiasEfectivos: number;
  HorasEfectivas: number;
}

/** Opciones de detalle del reporte Programa de Obra por concepto (índices TiposInsumos). */
export interface IOpcionesDetalleProgramaObraReporte {
  barra: boolean;
  montos: boolean;
  porcentajes: boolean;
  cantidades: boolean;
}

/** Geometría horizontal de columnas de periodo (cm). Se lee del molde en la plantilla. */
export interface ILayoutProgramaObraReporte {
  leftInicial: number;
  anchoColumna: number;
  anchoColumnaTotal: number;
}

export const PROGRAMA_OBRA_LAYOUT_DEFAULT: Readonly<ILayoutProgramaObraReporte> = {
  leftInicial: 14,
  anchoColumna: 3.4,
  anchoColumnaTotal: 3
};

/** Metadatos para clonar columnas dinámicas de periodo en Stimulsoft. */
export interface IMetaProgramaObraReporte {
  noPeriodos: number;
  titulosPeriodos: string[];
  opcionesDetalle: IOpcionesDetalleProgramaObraReporte;
  leftInicial: number;
  anchoColumna: number;
  anchoColumnaTotal: number;
  leftColumnaTotal: number;
  esPorPartida?: boolean;
  /** Reportes prog. suministro: barra Gantt continua (sin clonar por periodo). */
  usarGanttContinuo?: boolean;
}

export interface IResultadoProgramaObraReporte {
  data: any[];
  meta: IMetaProgramaObraReporte;
}

/** Fila resumida para listados de validación ProgSum (estilo ObtieneDtConError WinPlus). */
export interface IProgSumInsumoValidacion {
  codigo: string;
  descripcion: string;
  unidad?: string;
}

/** Validación 3: total programado vs ExpIns del cálculo. */
export interface IProgSumValidacionVolumen extends IProgSumInsumoValidacion {
  totalPrograma: number;
  totalCalculo: number;
}

/** Resultado de las 3 validaciones WinPlus clsRptProgSum.CicloReporte. */
export interface IValidacionesProgSumReporte {
  sinFechaInicio: IProgSumInsumoValidacion[];
  periodosNoAjustados: IProgSumInsumoValidacion[];
  volumenDesajustado: IProgSumValidacionVolumen[];
}

export interface IResultadoProgramaSuministroReporte extends IResultadoProgramaObraReporte {
  validaciones: IValidacionesProgSumReporte;
}

export class ClsReporteInsumo {
  Codigo: string;
  Descripcion: string;
  Unidad: string;
  Tipo: number;
  Costo: number;
  Expins: number;
  Importe: number;
  Familia: string;
  DescripcionFamilia: string;
  EsConceptosDelPpto: boolean;
  ExpInsl: boolean;
  Proveedor: string;
  RazonSocial: string;
  InsumoIntegrado: boolean;
  Fecha: Date;
  EsCostoHorario: boolean;
  PendienteAnalizar: boolean;
  EsPorcentaje: boolean;
  TipoPorcentaje: number;
  Clasificacion: string;
  TipoInsLetra: string;
  PorcentajeParticipacion: number;
  Nivel: number;
  Participa: boolean;
  Marca: boolean;
  SalarioBase?: number;
  FactorSalarioIntegrado?: number;
  Fasar?: number;
  SalarioIntegrado?: number;
  SalarioReal?: number;
  Viaticos?: number;
  AlimentacionHospedaje?: number;
  GastosSepelio?: number;
  OtrasPrestaciones?: number;
  TipoFasar?: number;
  RiesgosDeTrabajo?: number;
  ImporteTotalMO?: number;
  CostoTotal?: number;
}

export class ClsPartidasporNivel {
  LsPartidasNivel: ClsNivel[];
  Errores: ClsErrores;
}

export class ClsNivel {
  Nivel1: string;
  Nivel2: string;
  Nivel3: string;
  Nivel4: string;
  Nivel5: string;
  Nivel6: string;
  Nivel7: string;
  Nivel8: string;
  Nivel9: string;
  DescriNivel1: string;
  DescriNivel2: string;
  Descrinivel3: string;
  Descrinivel4: string;
  Descrinivel5: string;
  Descrinivel6: string;
  Descrinivel7: string;
  Descrinivel8: string;
  Descrinivel9: string;
  DescriCortaNivel1: string;
  DescriCortaNivel2: string;
  DescriCortaNivel3: string;
  DescriCortaNivel4: string;
  DescriCortaNivel5: string;
  DescriCortaNivel6: string;
  DescriCortaNivel7: string;
  DescriCortaNivel8: string;
  DescriCortaNivel9: string;
  Partida: string;
  DescripcionPartida: string;
  DescripcionPartidaLarga: string;
  PartidaWbs: string;
  CostoMoneda1: number;
  CostoMoneda2: number;
  PrecioMoneda1: number;
  PrecioMoneda2: number;
  PrecioIvaMoneda1: number;
  PrecioIvaMoneda2: number;
}
